module.exports = __webpack_public_path__ + "img/k-2_img.1b774b3b.png";